/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import {
  Boton,
  Titulo,
  Formulario,
  accessAPI,
  Sidebar,
  tituloBase,
  TablaFiltrable
} from "../../../shared";

// Acciones para el cliente: se vinculan muchos-a-muchos a los tipos de
// certificado, desde la ficha de cada acción. Un cliente con un proceso
// activo de un tipo vinculado ve la acción en su panel, una sola vez aunque
// tenga varios procesos que correspondan; también son sus etiquetas en el
// listado de clientes.
export default function AccionesCliente() {
  const [loader, setLoader] = useState(true);
  const [acciones, setAcciones] = useState([]);
  const [sideBar, setSideBar] = useState(false);
  const [formLoader, setFormLoader] = useState(false);
  const [formKey, setFormKey] = useState(0);

  const toast = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Acciones para clientes";
    accessAPI(
      "GET",
      "admin/config/accionescliente",
      null,
      (respuesta) => {
        setAcciones(respuesta);
        setLoader(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar acciones",
          sticky: true
        });
        setLoader(false);
      }
    );
    return () => (document.title = tituloBase());
  }, []);

  function crearAccion(contenidoCampos) {
    setFormLoader(true);
    accessAPI(
      "POST",
      "admin/config/accionescliente",
      contenidoCampos,
      (respuesta) => {
        navigate(`/config/accionescliente/${respuesta.id}`);
      },
      (respuesta) => {
        setFormLoader(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al crear la acción",
          sticky: true
        });
      }
    );
  }

  const formConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "nombre",
            tipoitemformularioid: 1,
            etiqueta: "Nombre",
            requerido: true,
            ayuda: "Es el título de la sección en el panel del cliente."
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Crear acción",
        callback: crearAccion,
        validar: true
      }
    ]
  };

  return (
    <>
      <Toast ref={toast} position="top-center" />

      <Sidebar
        visible={sideBar}
        onHide={() => setSideBar(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Nueva acción</Titulo>
        <Formulario key={formKey} config={formConfig} loader={formLoader} />
      </Sidebar>

      {loader && (
        <div
          css={{
            marginTop: "2em",
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem"
          }}
        >
          <div
            css={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "0.5rem"
            }}
          >
            <Skeleton width="15rem" height="2.5rem" />
            <Skeleton width="12rem" height="2.5rem" />
          </div>
          <Card>
            <div
              css={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem"
              }}
            >
              <Skeleton width="100%" height="3rem" />
              {[...Array(4)].map((_, i) => (
                <Skeleton key={i} width="100%" height="3.5rem" />
              ))}
            </div>
          </Card>
        </div>
      )}

      {!loader && (
        <div>
          <Titulo
            urlVolver="/config"
            botones={
              <Boton
                callback={() => {
                  setFormKey((k) => k + 1);
                  setSideBar(true);
                }}
              >
                Nueva acción
              </Boton>
            }
          >
            Acciones para clientes
          </Titulo>

          <Card>
            <TablaFiltrable conFiltros={false}
              value={acciones}
              nombreArchivo="acciones_cliente"
              emptyMessage="No hay acciones para clientes"
              stripedRows
              size="small"
              onRowClick={(e) => {
                if (e.originalEvent.metaKey || e.originalEvent.ctrlKey) {
                  window.open(`/config/accionescliente/${e.data.id}`, "_blank");
                } else {
                  navigate(`/config/accionescliente/${e.data.id}`);
                }
              }}
              css={{ "& .p-datatable-tbody > tr": { cursor: "pointer" } }}
            >
              <Column header="Nombre" field="nombre" />
            </TablaFiltrable>
          </Card>
        </div>
      )}
    </>
  );
}
